import axios from 'axios';
import Cookies from 'js-cookie';

import { API_URL } from 'constants'

export function getRound(id) {
  return axios.get(`${API_URL}/api/v1/rounds/${id}.json`, { withCredentials: true })
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);

      return null;
    })
}

export function getRounds() {
  return axios.get(`${API_URL}/api/v1/rounds.json`, { withCredentials: true })
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}

export function initRound() {
  return axios.get(`${API_URL}/api/v1/rounds/new.json`, { withCredentials: true })
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}

export function createRound(params) {
  const token = Cookies.get('csrf_token');

  return axios.post(`${API_URL}/api/v1/rounds.json`, params, { headers: { 'X-CSRF-TOKEN': token, withCredentials: true }})
    .then(response => response.data.data)
    .catch((response) => {
      console.log(response);
    })
}